import { suppliesTrackableProductIdFormat } from "@redotech/redo-marketplace-id";
import {
  SuppliesTrackableProductSchema,
  SuppliesTrackableProductTypeSchema,
} from "@redotech/redo-supplies-common/trackable-product";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

/**
 * Updates the editable fields of one trackable product. The supplies product is
 * locked — re-pointing it is a delete plus a create.
 */
export const updateTrackableProduct = unaryRpc({
  name: "updateTrackableProduct" as const,
  input: z.object({
    trackableProductId: suppliesTrackableProductIdFormat.schema,
    type: SuppliesTrackableProductTypeSchema.optional(),
    quantityPerCase: z.number().int().positive().optional(),
  }),
  output: z.object({ trackableProduct: SuppliesTrackableProductSchema }),
});
